import { get, IconCalendarBlank, TextInput } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import React, { useMemo } from 'react'
import { useFormStateContext } from '../../../providers'

import { toDateISOString } from './converters'

import './datetimeinput.css'

type Props = {
  label: string
  name: string
}

export function DatePicker(props: Props) {
  const { label, name } = props
  const { form, readOnly } = useFormStateContext()

  const value: Date | undefined = useWatch({ form, name })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputDate = event.target.valueAsDate

    if (!inputDate) {
      form.setValue(name, undefined)

      return
    }

    const newValue = value ? new Date(value) : new Date()

    if (inputDate) {
      newValue.setDate(inputDate.getUTCDate())
      newValue.setMonth(inputDate.getUTCMonth())
      newValue.setFullYear(inputDate.getUTCFullYear())
    }

    form.setValue(name, newValue)
  }

  const dateError = get(form.formState.errors, name)

  const formattedDate = useMemo(() => {
    if (!value) {
      return ''
    }
    return toDateISOString(value)
  }, [value])

  return (
    <TextInput
      label={label}
      type="date"
      disabled={readOnly}
      value={formattedDate}
      onChange={handleChange}
      prefix={<IconCalendarBlank />}
      error={!!dateError?.message}
      errorText={dateError?.message}
    />
  )
}
